<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_ix"></a><strong><em>Contents</em></strong></h2>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">Matilda’s Garden</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02">The Three Sons of Julia</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">The Importance of a Piece of Paper</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">The Valentine’s Day Card</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Enemies</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Mother’s Ashes</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Bull’s Blood</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Runaway</span></p>
<p class="noindent"><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?080a6704